import * as AuthHelper from './APIHelper';

export const GetEHR = () => {
    return AuthHelper.getResponse('/ehr');
}

export const GetEHRWithParams = (params) => {
    return AuthHelper.getResponse(`/ehr?${params}`);
}

export const PostEHR = (payload) => {
    return AuthHelper.postResponse('/ehr', payload);
}  

export const PutEHR = (id, payload) => {
    return AuthHelper.putResponse(`/ehr/${id}`, payload);
}

export const DeleteEHR = (id) => {
    return AuthHelper.deleteResponse(`/ehr/${id}`);
}